import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { getAthleteDetailsInfoPath, UserInfo } from '@libs/entity-lib';
import { setUserInfo } from '../../core/store/profile/profile.actions';
import * as fromProfileActions from '../../core/store/profile/profile.actions';
import { selectIsUserNameValid, selectSportCenterLoading, selectUserInfo } from '../../core/store/profile/profile.selectors';
import { map, take } from 'rxjs';


import { CommonModule } from '@angular/common';
import { TranslationLibModule } from '@libs/translation';

import { IonBackButton, IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonInput, IonItem, IonSpinner, IonTitle, IonToolbar } from '@ionic/angular/standalone';

@Component({
    selector: 'crud-credential-info',
    templateUrl: 'credential-info.component.html',
    styleUrls: ['credential-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    IonBackButton,
    IonButton,
    IonButtons,
    IonContent,
    IonFooter,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonSpinner,
    IonTitle,
    IonToolbar,
    CommonModule,
    ReactiveFormsModule,
    TranslationLibModule
  ]
})
export class CredentialInfoComponent implements OnInit {
    private store = inject(Store);
    private router = inject(Router);


    isLoading$ = this.store.select(selectSportCenterLoading);
    isUserNameValid$ = this.store.select(selectIsUserNameValid);
    selectUserInfo$ = this.store.select(selectUserInfo);
    form: FormGroup;

    constructor() {
        this.form = new FormGroup({
            username: new FormControl('', Validators.compose([Validators.required, Validators.minLength(3)]))
          });
    }

    createForm() {
      this.form = new FormGroup({
        username: new FormControl('', Validators.compose([Validators.required, Validators.minLength(3)]))
      });
    }

    ngOnInit(): void {
      this.selectUserInfo$.pipe(
        take(1),
        map((userInfo) => {
          if (userInfo) {
            this.form.patchValue(userInfo);
          }
        })
      ).subscribe();
    }

    gotNextPage() {
      const userInfo = { username: this.getUserNameFromForm() } as UserInfo;
      this.store.dispatch(setUserInfo({ userInfo }));
      this.router.navigate([getAthleteDetailsInfoPath()]);
    }

    onUserNameChange(): void {
      const isValid = this.form.get('username')?.valid;
      if (isValid) {
        const userName = this.getUserNameFromForm();
        this.store.dispatch(fromProfileActions.verifyUserName({ userName }));
      }
    }

    private getUserNameFromForm() {
      return this.form.get('username')?.value?.trim() ?? '';
    }
}
